import { FieldType, TableColumnMetadata } from "./types";

export class ApplicationCustomersSchema {
	static dployTesterContext: string = "ApplicaitonCustomers";
	static isReadOnlyRow = (rowData: any, cells: any) =>
		rowData?.engagementCustomerId &&
		rowData.engagementCustomerId !== rowData.customerId;
	static metaData: Partial<Record<keyof any, TableColumnMetadata>> = {
		phoneMobile: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		email: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		customerNumber: {
			fieldType: FieldType.Text,
			isRequired: true
		},
		customerRole: {
			fieldType: FieldType.Select,
			isRequired: true
		}
	};
}
